import React from 'react';

//https://reactjs.org/docs/lists-and-keys.html#extracting-components-with-keys
class ServiceItem extends React.Component {

	constructor() {
		super();
	}
	

	//https://reactjs.org/docs/dom-elements.html#dangerouslysetinnerhtml
	desc() {
        let desc = this.props.desc;
        return { __html: desc };			
	}

	render() {

		return (
			<li className="content-box item__service">
			    <a href={this.props.url} title={this.props.title}>
			        <div className="box__body white-text">
			            <div className="service__title center">
			                <h3>{this.props.title}</h3>
			                <h4 className="service__original-name original-name">{this.props.original_name}</h4>
			                
						{this.props.duration.length > 0 && 
							<div className="service__info">
							<figure className="ico">
								<img loading="lazy" src={`${wp_core.theme_url}/assets/img/ico/time.svg`} />
							</figure>
							<dl>
								<dt>{l18n.duration}</dt>
								<dd>{this.props.duration}</dd>
							</dl>
						</div>				
						}

			            </div>
						<p className="service__desc" dangerouslySetInnerHTML={this.desc()} />
						<span className="button button--transparent button--compact button--center">{l18n.cta}</span>
			        </div>

				<figure className="box__cover cover cover--overlay">
					{this.props.cover ? (
						<img laoding="lazy" src={this.props.cover} alt={this.props.title} />
					) : (
						<img loading="lazy" src={`${wp_core.theme_url}/assets/img/service-cover-default.jpg`} alt={this.props.title} />
					)}
				</figure>
	
			    </a>
			</li>

		);
	}
}

export default ServiceItem;